var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowTimtable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 21,
    viewBox: "0 0 37 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0982 0.49252C27.4416 -0.164173 26.3766 -0.164173 25.7198 0.49252C25.063 1.14921 25.063 2.21414 25.7198 2.87095L31.2579 8.40906H1.68182C0.753006 8.40906 0 9.16207 0 10.0909C0 11.0197 0.753006 11.7727 1.68182 11.7727H31.2579L25.7199 17.3108C25.0631 17.9675 25.0631 19.0324 25.7199 19.6892C26.0482 20.0175 26.4787 20.1818 26.9091 20.1818C27.3395 20.1818 27.77 20.0175 28.0982 19.6891L36.5073 11.28C37.1641 10.6233 37.1641 9.55842 36.5073 8.90161L28.0982 0.49252Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowTimtable);
export default __webpack_public_path__ + "static/media/arrow_timtable.e30daca2.svg";
export { ForwardRef as ReactComponent };